/**
 * Format shipping notification message
 * @param {Object} options - Message options
 * @param {string} options.customerName - Customer's name
 * @param {string} options.courierName - Courier name (e.g., 'J&T Courier')
 * @param {string} options.productName - Name of the product
 * @param {string} options.trackingNumber - Tracking number
 * @param {string} [options.trackingLink='https://jet.co.id/track'] - Tracking link
 * @param {string} [options.companyName='VONE'] - Company name for signature
 * @returns {string} Formatted message
 */
const formatShippingNotification = ({
    customerName,
    courierName,
    productName,
    trackingNumber,
    trackingLink = 'https://jet.co.id/track',
    companyName = 'VONE'
  }) => {
    return `Dear ${customerName.toUpperCase()},  \n\nWe are pleased to inform you that your package has been shipped via ${courierName}. Below are the details of your shipment:\n\n${productName ? productName.toUpperCase() : ''}\n\nTracking Number: ${trackingNumber}\nYou can track your shipment at the following link:  ${trackingLink}\n\nPlease record an unboxing video upon receiving your product, as we cannot accept exchanges or complaints without it. The deadline to submit any complaints is H+7 days after the package is received. \n\nThank you for your order!\n\nBest regards,\n${companyName}`;
  };
  
  /**
   * Get tracking URL for a courier
   * @param {string} courierCode - Courier code (e.g., 'JNE', 'J&T')
   * @param {string} trackingNumber - Tracking number
   * @returns {string} Tracking URL
   */
  const getTrackingUrl = (courierCode, trackingNumber) => {
    const courierUrls = {
      'EZ': `https://jet.co.id/track?id=${trackingNumber}`,
      'JTR': `https://jne.co.id/tracking-package`,
      'CTCYES': `https://jne.co.id/tracking-package`,
      'CTC': `https://jne.co.id/tracking-package`,
      'POS': `https://www.posindonesia.co.id/en/tracking/${trackingNumber}`,
      'SICEPAT': `https://www.sicepat.com/`,
      'LION': `https://lionparcel.com/track/stt?q=${trackingNumber}`,
      'PAXEL': `https://paxel.co.id/track?id=${trackingNumber}`,
      'JAGOPACK': `https://lionparcel.com/track/stt?q=${trackingNumber}`,
      'REGPACK': `https://lionparcel.com/track/stt?q=${trackingNumber}`,
      'BIGPACK': `https://lionparcel.com/track/stt?q=${trackingNumber}`,
      'BOSSPACK': `https://lionparcel.com/track/stt?q=${trackingNumber}`,
    };
  
    return courierUrls[courierCode] || `https://jet.co.id/track?id=${trackingNumber}`;
  };
  
  export { formatShippingNotification, getTrackingUrl };